/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  UpdateSurrogateNotificationsErrorResponse,
  UpdateSurrogateNotificationsRequest,
} from './api.schemas';

import { api } from '../util/http';

export const updatePatientSurrogateNotifications = (
  patientId: string,
  updateSurrogateNotificationsRequest: UpdateSurrogateNotificationsRequest,
) => {
  return api<void>({
    url: `/api/patient/${patientId}/surrogate-notifications`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateSurrogateNotificationsRequest,
  });
};

export const getUpdatePatientSurrogateNotificationsMutationOptions = <
  TError = UpdateSurrogateNotificationsErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePatientSurrogateNotifications>>,
    TError,
    { patientId: string; data: UpdateSurrogateNotificationsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePatientSurrogateNotifications>>,
  TError,
  { patientId: string; data: UpdateSurrogateNotificationsRequest },
  TContext
> => {
  const mutationKey = ['updatePatientSurrogateNotifications'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePatientSurrogateNotifications>>,
    { patientId: string; data: UpdateSurrogateNotificationsRequest }
  > = (props) => {
    const { patientId, data } = props ?? {};

    return updatePatientSurrogateNotifications(patientId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePatientSurrogateNotificationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePatientSurrogateNotifications>>
>;
export type UpdatePatientSurrogateNotificationsMutationBody = UpdateSurrogateNotificationsRequest;
export type UpdatePatientSurrogateNotificationsMutationError =
  UpdateSurrogateNotificationsErrorResponse;

export const useUpdatePatientSurrogateNotifications = <
  TError = UpdateSurrogateNotificationsErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePatientSurrogateNotifications>>,
      TError,
      { patientId: string; data: UpdateSurrogateNotificationsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePatientSurrogateNotifications>>,
  TError,
  { patientId: string; data: UpdateSurrogateNotificationsRequest },
  TContext
> => {
  const mutationOptions = getUpdatePatientSurrogateNotificationsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
